var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.042h10v-1.75H5Zm0 3.416h6.667v-1.75H5Zm-1.583 3.209q-.729 0-1.24-.511-.51-.51-.51-1.239V5.083q0-.729.51-1.239.511-.511 1.24-.511H8.25L10 5.083h6.583q.729 0 1.24.511.51.51.51 1.239v8.084q0 .729-.51 1.239-.511.511-1.24.511Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicIcon);
export default __webpack_public_path__ + "static/media/topic-icon.6ea81601e510b9a8fb7088f7523d0279.svg";
export { ForwardRef as ReactComponent };